import React, { useEffect, useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { openVoiceflowChat } from '../lib/voiceflow';

/**
 * Floating "Kysy agentilta" launcher.
 * Loads the Voiceflow bundle ONLY when the user clicks the button —
 * no CDN request happens on initial page load.
 * Hidden while the cookie banner is open (body[data-consent-open="true"])
 * or when the visitor is focused on the contact form.
 */
const ChatLauncher = () => {
  const [loading, setLoading] = useState(false);
  const [opened, setOpened] = useState(false);

  const handleClick = async () => {
    if (opened) {
      // If already loaded, just re-open
      openVoiceflowChat();
      return;
    }
    setLoading(true);
    await openVoiceflowChat();
    setLoading(false);
    setOpened(true);
  };

  useEffect(() => () => { /* noop cleanup */ }, []);

  // Hidden when the Voiceflow bundle has taken over — Voiceflow renders its
  // own floating button once loaded. We hide ours after first open.
  if (opened) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[80] inline-flex items-center gap-2 h-11 md:h-12 pl-4 pr-5 rounded-full bg-[#171716] text-white font-medium text-[13.5px] md:text-[14px] shadow-2xl border border-white/10 hover:bg-[#2a2a28] transition-all duration-200 hover:-translate-y-0.5 chat-launcher"
      data-testid="chat-launcher-button"
      aria-label="Avaa keskustelu brändiagentin kanssa"
    >
      <MessageSquare className="w-4 h-4" strokeWidth={2} />
      {loading ? 'Ladataan…' : 'Kysy agentilta'}
    </button>
  );
};

export default ChatLauncher;
